<template>
  <!-- 短连接地址 -->
  <div class="short-url"></div>
</template>

<script>
export default {
  name: 'short-url',

  created() {
    let serialNumber = atob(this.$route.params.serialNumber)

    let redirect_uri = encodeURI(
      `${this.$web_url}anonymity-query-mobile/${serialNumber}`
    )
    location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${this.$app_id}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_base#wechat_redirect`
  }
}
</script>

